import { Pipe, PipeTransform } from '@angular/core';
import { ISignField } from '@app/transaction-builder/model/sign-field.model';

@Pipe({
  name: 'filterSignFieldsOnPage',
})
export class FilterSignFieldsOnPagePipe implements PipeTransform {
  transform(signFields: ISignField[], pageIndex: number): ISignField[] {
    return signFields.filter((signField) => signField.pageIndex === pageIndex);
  }
}
